<template>
    <div class="about">
        <h1>This is an about page</h1>
        <button @click.prevent="getToken">Get token</button>


        <h2>Check runners following for a runner</h2>
        <button @click.prevent="checkRunnerForARace">Check</button>
        <p class="text-white">{{JSON.stringify(raceRunners)}}</p>
    </div>
</template>
<script>
  import {apiUrl, fetchGet} from "../commons";

    export default {
        data() {
            return {
                raceRunners: []
            };
        },
        methods: {
            async getToken() {
              console.log('getting token');
              const [err, response] = await fetchGet(`${apiUrl}/users/token`);
              console.log(err, response);
            },
            async checkRunnerForARace() {
                const raceCode = "G_Launceston_20200124_1";
                const [err, response] = await fetchGet(`${apiUrl}/followings/race/check-runner/${raceCode}`);
                console.log('checkRunnerForARace', err, response);
                this.raceRunners = response;
            }
        }
    }
</script>
